export const SYNC = 'sync';
export const SEND_TO = 'sendTo';
export const DEPOSIT = 'deposit';
export const WITHDRAW = 'withdraw';
export const CREATE_CHANNEL = 'channelCreate';
export const CANCEL_WITHDRAW = 'cancelWithdraw';
export const PREPARE_WITHDRAW = 'prepareWithdraw';
export const TRANSACTION_SOMETHING_WENT_WRONG = 'somethingWentWrong';

export const contractTransactionMapping = {
  Sync: SYNC,
  Send: SEND_TO,
  Deposit: DEPOSIT,
  ChannelCreate: CREATE_CHANNEL,
  Withdraw: WITHDRAW,
  'Withdraw Request': PREPARE_WITHDRAW,
  'Cancel Withdraw': CANCEL_WITHDRAW,
};
